import { COMMON } from "../../../util/localizations";

const TRANSLATIONS = {
    en: {
        connect: COMMON.en.install,
        makeOffer: COMMON.en.makeOffer,
        noDataBody: "Be the first to market!",
        noDataTitle: "There are no NFTs",
        notConnectedTitle: COMMON.en.notConnectedTitle,
        notConnectedBody: COMMON.en.notConnectedBody,
        notInstalled: `You must have a ${ COMMON.en.metamask } wallet installed to view the marketplace.`,
        showOwned: 'Show NFTs you own',
        subtitle: `Make an offer on an existing ${ COMMON.appName } NFT.`,
        title: COMMON.en.marketplace,
        tokenHistory: COMMON.en.tokenHistory,
        youMustBeConnected: `You need to connect to ${ COMMON.en.metamask} before making an offer.`
    }
}

export default TRANSLATIONS